import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { Currency } from '@/models/Currency';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function useCurrency() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getCurrencies = useCallback(async (): Promise<Currency[]> => {
    const fetchUrl = `${baseUrl}currency`;

    const response = await customFetch<Currency[]>(fetchUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });

    return response;
  }, [authResult, customFetch]);

  return {
    getCurrencies,
  };
}
